var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"scroll-top",attrs:{"href":"#top"}},[_c('i',{staticClass:"fa fa-angle-double-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }